import React from 'react'
import { Card, Icon } from 'antd'
import './AspectRatioSelector.scss'

const RATIO_CONFIGS = [
  {
    ratio: '9:16',
    label: 'Vertical',
    platform: 'TikTok, Reels, Shorts',
    icon: 'mobile'
  },
  {
    ratio: '16:9',
    label: 'Widescreen',
    platform: 'YouTube, LinkedIn, TV',
    icon: 'desktop'
  },
  {
    ratio: '1:1',
    label: 'Square',
    platform: 'Instagram, FB Posts',
    icon: 'instagram'
  },
  {
    ratio: '4:5',
    label: 'Portrait',
    platform: 'Instagram Feed',
    icon: 'picture'
  },
  {
    ratio: '21:9',
    label: 'Cinematic',
    platform: 'Cinema, Ultra-wide',
    icon: 'video-camera'
  },
  {
    ratio: '4:3',
    label: 'Classic',
    platform: 'Standard TV / Monitor',
    icon: 'tv'
  },
  {
    ratio: '3:2',
    label: 'Standard',
    platform: 'DSLR, 35mm Format',
    icon: 'camera'
  },
  {
    ratio: '2:3',
    label: 'Tall',
    platform: 'Pinterest, Posters',
    icon: 'file-image'
  }
]

const RatioIcon = ({ ratio, active }) => {
  const [w, h] = ratio.split(':').map(Number)
  const isHorizontal = w > h

  // Max dimension for the icon container
  const max = 32
  let width, height

  if (isHorizontal) {
    width = max
    height = (h / w) * max
  } else {
    height = max
    width = (w / h) * max
  }

  return (
    <div
      className={`ratio-preview-box ${active ? 'active' : ''}`}
      style={{
        width: `${width}px`,
        height: `${height}px`
      }}
    />
  )
}

const AspectRatioSelector = ({ value, onChange }) => {
  return (
    <div className="aspect-ratio-selector">
      <div className="ratio-grid">
        {RATIO_CONFIGS.map(config => (
          <div
            key={config.ratio}
            className={`ratio-card ${value === config.ratio ? 'active' : ''}`}
            onClick={() => onChange(config.ratio)}
          >
            <div className="ratio-card-content">
              <div className="ratio-visual">
                <RatioIcon
                  ratio={config.ratio}
                  active={value === config.ratio}
                />
              </div>
              <div className="ratio-info">
                <div className="ratio-meta">
                  <span className="ratio-value">{config.ratio}</span>
                  <span className="ratio-name">{config.label}</span>
                </div>
                <div className="ratio-platform">
                  <span>{config.platform}</span>
                </div>
              </div>
            </div>
            {value === config.ratio && (
              <div className="selection-badge">
                <Icon type="check-circle" theme="filled" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default AspectRatioSelector
